import dynamic from 'next/dynamic'
import { type FC } from 'react'

import { useGetLocation } from '@/hooks/location/useGetLocation'
import { useLocale } from '@/hooks/useLocale'
import { trackEvent } from '@/lib/ga'
import { GA_CTA_HEADER } from '@/lib/ga/constants/ga'
import { GA_EVENT } from '@/lib/ga/constants/gaEvent'

import { SearchLocationModal } from '../../search-location-modal'
import { LocationButton, LocationIconContainer, LocationName, LocationRadius } from './styled'

const LocationOutlineIcon = dynamic(() => import('@kijiji/icons/src/icons/LocationOutline'), {
  ssr: false,
})

export const SearchLocation: FC = () => {
  const { location } = useGetLocation()
  const { apiLocale } = useLocale()

  const handleLocationClick = (openModal: () => void) => {
    trackEvent({ action: GA_EVENT.LocationSelectBegin, label: GA_CTA_HEADER })
    openModal()
  }

  /**
   * It should use location name if is a region, or address with fallback on the name if is not an exact location.
   */
  const locationName = location.isRegion
    ? location.name[apiLocale]
    : location.area?.address || location.name[apiLocale]

  return (
    <>
      <SearchLocationModal>
        {(openModal) => (
          <LocationButton
            data-testid="set-search-range"
            forwardedAs="button"
            onClick={() => handleLocationClick(openModal)}
            size="medium"
            variant="secondary"
          >
            <LocationIconContainer>
              <LocationOutlineIcon aria-hidden="true" />
            </LocationIconContainer>

            <LocationName data-testid="location-name">{locationName}</LocationName>

            {!location.isRegion && !!location.area && (
              <LocationRadius data-testid="location-radius">
                {` • `}
                {location.area.radius}km
              </LocationRadius>
            )}
          </LocationButton>
        )}
      </SearchLocationModal>
    </>
  )
}
